import React, { useState } from 'react';
import './Contact.css';


const ContactForm = () => {
  const [form, setForm] = useState({name: '', email: '', message: ''});
  const [status, setStatus] = useState(null);

  const handleChange = (e) => {
    setForm({...form, [e.target.name]: e.target.value});
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // handle form submission
    setStatus('Message sent!');
  };

  return (
    <div className="contact-block-container" id="contact" >
  
      <form onSubmit={handleSubmit}>
        <input
          name="name"
          type="text"
          placeholder="Your Name"
          value={form.name}
          onChange={handleChange}
          required
        />
        <input
          name="email"
          type="email"
          placeholder="Your Email"
          value={form.email}
          onChange={handleChange}
          required
        />
        <textarea
          name="message"
          rows="6"
          placeholder="Your Message"
          value={form.message}
          onChange={handleChange}
          required
        />
        <button type="submit">Send Message</button>
        {status && <div>{status}</div>}
      </form>
    </div>
  );
};

export default ContactForm;
